// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Metals from './Metals';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Metals);
